import { iframeResizer } from 'iframe-resizer';
import UserAccount from './user-account/UserAccount.mjs';

// Automatically resizes the iframe
!(function ($) {
  $(function () {
    $('#booking-engine-iframe').iFrameResize({ log: false });
  });
})(jQuery);

// Scroll back to the top when the user goes to the next/previous step in the booking process
// Snippet provided by Caxy on 1/26/21
function receiveMessage(event) {
  if (event && event.data === 'BOOKING_ENGINE_PAGE_CHANGED') {
    const iframeTop = document.getElementById('booking-engine-iframe');
    iframeTop.scrollIntoView(true);
  }
}
window.addEventListener('message', receiveMessage, false);

/*
Dynamically update the parameters in the iframe URL so we can pass variables from our site into the booking engine.
Then swap out the iframe src with the dynamically generated URL. This is used to pass in the user's auth token if
they're logged in, so the booking engine is aware of their existing session and they don't have to log in again. It's
also used to pass along discount codes that might be included in our page's URL.
 */
document.querySelectorAll('iframe[data-lazy-load-src]').forEach(iframe => {
  let src = iframe.getAttribute('data-lazy-load-src');

  if (iframe.getAttribute('data-pass-auth') === 'true' && UserAccount.isLoggedIn()) {
    src = src + '&token=' + UserAccount.getAuthToken();
  }

  let discountCode = location.search.match(/discountCode=([^&]+)/);
  if (discountCode !== null) {
    discountCode = discountCode[1];
    src = src + '&discountCode=' + discountCode;
  }

  iframe.setAttribute('src', src);
});
